import React from 'react';
import ErrorBoundary from './ErrorBoundry';

const withErrorBoundary = (Component) => (props) => {
  return (
    <ErrorBoundary>
      <Component {...props} />
    </ErrorBoundary>
  );
};

export default withErrorBoundary;
